<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";
    import { fade } from 'svelte/transition';
    import { Dropdown } from "carbon-components-svelte";
    import { sessionId } from "../../utils/store";
    import LocationInfo from "../admin/locationinfo.svelte";

    import {
        errorReasons,
        updateUserStatus,
        createProperty,
        listProperties, logout
    } from "../api.svelte";

    import {
        getLocalSessionId,
        getLocalUserStatus,
        getLocalPropertyId,
        getStatusRoute, managePropertiesMeta, sessionCleanup
    } from "../../utils/session";


    const ERROR_DISAPPEAR_AFTER = 5500;


    const router = getContext('router');

    let formError = false;
    let isLoading = false;
    let errorResetTimer = null;


    onMount(() => {

        let localSessionId = getLocalSessionId();
        let localStatus = getLocalUserStatus();

        if (!localSessionId || !localStatus) {

            router.route('/login');
            return;

        }

        if (getLocalPropertyId()) {

            localStorage.setItem('kstatus', 'onboarding_integrations');
            router.route('/integrations');

            return;

        }

        if (localStatus !== 'onboarding_locations') {

            router.route(getStatusRoute(localStatus));
        }

    });

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let propertyHandler = (evt) => {

        if (isLoading) return;

        const details = evt.detail['details'];

        if (details['title'] === '' || details['address'] === ''
            || details['city'] === '' || details['zip'] === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        createProperty(evt.detail['category'], details).then((createResult) => {

            isLoading = false;

            if (createResult['status'] !== 'success') {

                formError = createResult['reason'];
                startErrorResetTimer();

                return;

            }

            listProperties().then((listResult) => {

                if (listResult['status'] !== 'success') {

                    // TODO: Handle errore
                    console.log(listResult);

                    return;

                }

                managePropertiesMeta(listResult['properties']);

                localStorage.setItem('kstatus', 'onboarding_integrations');
                updateUserStatus('onboarding_integrations');

                router.route('/integrations');

            });

        });

    };

    let logoutHandler = () => {

        logout().then((_) => {

            sessionId.set('');
            sessionCleanup();
            router.route('/login');

        });

    };

</script>


<div class="onboarding-logout" on:click={() => logoutHandler()}>

    <img src="/images/icons/nav/logout.svg" alt="">
    <span>Logout</span>

</div>

<div class="onboarding-text">

    <div class="headline-styler"></div>

    <h2>
        Ihren ersten Standort einrichten.
    </h2>

</div>

<div id="locations-container" class="forms-container">

    <LocationInfo
            formError={formError}
            isLoading={isLoading}
            on:saved={propertyHandler} />

</div>


<style>

    .onboarding-text {
        margin-right: 21.66vh;
    }

    @media screen and (max-width: 1024px) {

        .onboarding-text {
            margin-top: 6vw;
            margin-right: 0;
        }

        #locations-container {
            margin-top: 8vw;
        }

    }

</style>
